// extracted by mini-css-extract-plugin
export default {"botaoAdicionarMusica":"BotaoAdicionarMusica_botaoAdicionarMusica__4e10N","input":"BotaoAdicionarMusica_input__FnAiR"};